import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=2deb7a6c&scoped=true"
import script from "./Remind.vue?vue&type=script&lang=js"
export * from "./Remind.vue?vue&type=script&lang=js"
import style0 from "./Remind.vue?vue&type=style&index=0&id=2deb7a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb7a6c",
  null
  
)

export default component.exports